import { useEffect } from 'react';
import { AccessTime } from '@material-ui/icons';

import { logger, LogType } from 'core/atoms/housekeeping';

import { Skeleton } from 'core/cells/skeleton';
import { GridContainer, GridItem } from 'templates/mdp/components/grid';
import {
  Card,
  CardBody,
  CardHeader,
  CardIcon,
} from 'templates/mdp/components/card';
import { Table } from 'templates/mdp/components/react-table';
import { useStyles } from 'templates/mdp/views/tables/react-tables.styles';
import { createReactTableStore } from 'core/memory/pure/react-table-store';
import { useGetTermsState } from 'core/memory/apollo/terms/local/get-terms-state';
import { useReactTableState } from 'core/metabolism/table-state';
import { useSleepHoursTableRead } from './use-sleep-hours-table-read';

export const sleepHoursTableStore = createReactTableStore({}, {});

export const SleepHoursTable = () => {
  const classes = useStyles();
  const { data: termsState } = useGetTermsState();
  const { columns, data, loading, title } = useSleepHoursTableRead();

  const {
    initialPage,
    pageSize,
    sort,
    filters,
    setSort,
    setFilters,
    setPage,
    setPageSize,
  } = useReactTableState(
    sleepHoursTableStore,
    termsState?.selected ?? undefined,
  );

  useEffect(() => {
    logger.debug({
      title: 'did mount',
      type: LogType.Info,
      logger: 'sleep-hours-table',
    });
  }, []);

  return loading || !termsState?.selected ? (
    <Skeleton variant="rect" width="100%" height="80vh" />
  ) : (
    <GridContainer spacing={3} justify="center">
      <GridItem xs={12} lg={8} xl={6}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <AccessTime />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>{title}</h4>
          </CardHeader>
          <CardBody>
            <Table
              noActions
              columns={columns}
              data={data ?? []}
              key={termsState.selected}
              onChangeRowsPerPage={setPageSize}
              onChangePage={setPage}
              onFilterChange={setFilters}
              onOrderChange={setSort}
              options={{
                initialPage,
                pageSize,
                sort,
                filters,
              }}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};
